<c-card class="mb-5">
  <c-card-header>
    <!-- <app-date-to-date-search></app-date-to-date-search> -->
    <div class="d-flex justify-content-between align-items-center py-2">
      <app-date-to-date-search (dateToDateSearch)="dateToDateSearch($event)"></app-date-to-date-search>
      <c-button-group class="btn btn-primary" role="group">
        <button cButton class="btn-primary" (click)="handleDoc('pdf')">PDF</button>
        <button cButton class="btn-primary" (click)="handleDoc('csv')">CSV</button>
        <button cButton class="btn-primary" (click)="handleDoc('xls')">XLS</button>
      </c-button-group>
    </div>
  </c-card-header>
  <c-card-body>

    <!-- <div class="d-flex justify-content-end p-3"></div> -->
    <div class="table-responsive">
      <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 responsive-table">
        <!-- <ng-container matColumnDef="created At" *ngIf="!isLoading">
        <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
          <div class="header-name d-flex align-items-center" (click)="sortData('createdDate')">
            Created At
            <mat-icon class="sorting-icon" *ngIf="sorting.column === 'createdDate'">
              {{ sorting.direction === 1 ? 'arrow_upward' : 'arrow_downward' }}
            </mat-icon>
          </div>
          <mat-form-field>
            <input matInput [matDatepicker]="picker" (dateInput)="onDateChange($event, 'createdDate')"
              (dateChange)="onDateChange($event, 'createdDate')" placeholder="MM/DD/YYYY">
            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.createdDate | date:'medium' }}
        </td>
      </ng-container> -->

      <ng-container matColumnDef="Order No" *ngIf="!isLoading">
        <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
          <div class="header-name d-flex align-items-center" (click)="sortData('liquidityId')">
            Order No
            <mat-icon class="sorting-icon" *ngIf="sorting.column === 'firstCurrency'">
              {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
            </mat-icon>
          </div>
          <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'liquidityId')">
            <input matInput placeholder="Search"  />
          </mat-form-field>
        </th>
        <td mat-cell *matCellDef="let element">
          {{ element.liquidityId }}
        </td>
      </ng-container>

        <ng-container matColumnDef="Date" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('orderDate')">
              Date
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'orderDate'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field>
              <input matInput [matDatepicker]="picker" (dateInput)="onDateChange($event, 'orderDate')"
                (dateChange)="onDateChange($event, 'orderDate')" placeholder="MM/DD/YYYY">
              <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.orderDate | date:'medium' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Reference Id" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('_id')">
              Reference Id
              <mat-icon class="sorting-icon" *ngIf="sorting.column === '_id'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, '_id')">
              <input matInput placeholder="Search" alphaNumeric />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element._id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('name')">
             Name
              <mat-icon class="sorting-icon" *ngIf="sorting.column === '_id'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'name')">
              <input matInput placeholder="Search" alphaNumeric />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.name }}
          </td>
        </ng-container>

        <ng-container matColumnDef="User Id" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('userCode')">
              User Id
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'userCode'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'userCode')">
              <input matInput placeholder="Search" numbersOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.userCode }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Base Currency" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('firstCurrency')">
              Base Currency
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'firstCurrency'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'firstCurrency')">
              <input matInput placeholder="Search" alphaOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.firstCurrency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Quote Currency" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('secondCurrency')">
              Quote Currency
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'secondCurrency'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'secondCurrency')">
              <input matInput placeholder="Search" alphaOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.secondCurrency }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Type" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('orderType')">
              Type
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'orderType'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'orderType')">
              <input matInput placeholder="Search" alphaOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.orderType }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Side" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('buyorsell')">
              Side
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'buyorsell'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'buyorsell')">
              <input matInput placeholder="Search" alphaOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.buyorsell }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Execute price" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('execPrice')">
              Execute price
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'execPrice'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'execPrice')">
              <input matInput placeholder="Search" numbersOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ convert(element.execPrice) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Price" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('Price')">
              Price
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'Price'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'Price')">
              <input matInput placeholder="Search" />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.Price == 'market' ? 'Market' : convert(element.Price) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Filled Amount" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('filledQuantity')">
              Filled Amount
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'filledQuantity'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'filledQuantity')">
              <input matInput placeholder="Search" numbersOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ convert(element.filledQuantity) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Amount" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('openQuantity')">
              Amount
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'openQuantity'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'openQuantity')">
              <input matInput placeholder="Search" numbersOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ convert(element.openQuantity) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Total" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('averagePrice')">
              Total
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'averagePrice'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'averagePrice')">
              <input matInput placeholder="Search" numbersOnly />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ convert(element.averagePrice) }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Liquidity" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('liquidityType')">
              Liquidity
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'liquidityType'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'liquidityType')">
              <input matInput placeholder="Search" />
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.liquidityType | titlecase }}
          </td>
        </ng-container>

        <ng-container matColumnDef="Status" *ngIf="!isLoading">
          <th mat-header-cell *matHeaderCellDef class="cursor-pointer">
            <div class="header-name d-flex align-items-center" (click)="sortData('status')">
              Status
              <mat-icon class="sorting-icon" *ngIf="sorting.column === 'status'">
                {{ sorting.direction === 1 ? "arrow_upward" : "arrow_downward" }}
              </mat-icon>
            </div>
            <mat-form-field appearance="outline" class="small-input" (input)="onInputChange($event, 'status')">
              <mat-select appearance="outline" class="small-input" [(value)]="selectedStatus"
                (selectionChange)="onOptionChange($event, 'status')">
                <mat-option *ngFor="let option of statusOptions" [value]="option">{{
                  option | titlecase
                  }}</mat-option>
              </mat-select>
            </mat-form-field>
          </th>
          <td mat-cell *matCellDef="let element">
            {{ element.status | titlecase }}
          </td>
        </ng-container>
      
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ 'hide-data': isLoading }"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="9999" class="p-4">
            <strong class="text-secondary">No record found!</strong>
          </td>
        </tr>
      </table>
      <div *ngIf="isLoading" class="spinner-container">
        <mat-progress-spinner color="primary" mode="indeterminate" diameter="50">
        </mat-progress-spinner>
      </div>
    </div>
    <!-- <table>
    <tr *ngIf="dataSource.data.length == 0">
      <td style="text-align: center;" [attr.colspan]="displayedColumns.length">
        No Records Found!
      </td>
    </tr>
  </table> -->
    <mat-paginator [length]="totalRows" [pageIndex]="currentPage" [pageSize]="pageSize"
      [pageSizeOptions]="pageSizeOptions" showFirstLastButtons aria-label="Select page of periodic elements"
      (page)="pageChanged($event)">
    </mat-paginator>
  </c-card-body>

</c-card>